import axios from '../../plugins/axios';

/**

 * @param {Object} data - Данные покупателя
 * @param {number} data.CarId - ID автомобиля
 * @param {string} data.JuridicalName - Наименование юр. лица
 * @param {string} data.JuridicalDirectorName - ФИО директора
 * @param {string} data.CompanyDetails - Реквизиты компании
 * @param {string} data.ContractNumber - Номер договора
 * @param {string} data.RepairWorkList - Список работ
 * @returns {Promise<Object>}
 */
export async function createBuyer(data) {
  const formData = new FormData();
  formData.append('json', JSON.stringify(data));

  const response = await axios.post(
    '/api/crm/cars/createBuyer', formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      withCredentials: true,
    }
  );
  return response.data;
} 